import LegalPageLayout from "@/components/LegalPageLayout";

export default function Terms() {
  return (
    <LegalPageLayout
      title="Terms & Conditions"
      description="The terms governing your use of the College Unlock platform."
      updated="June 2026"
      testid="terms-page"
    >
      <p>
        These Terms &amp; Conditions govern your use of the College Unlock platform and services. By
        using our platform, you agree to these terms.
      </p>

      <h2>Our Services</h2>
      <p>
        College Unlock provides college discovery, comparison and AI-powered admission guidance.
        Our guidance and recommendations are intended to help you make informed decisions and do not
        guarantee admission to any institution.
      </p>

      <h2>Your Responsibilities</h2>
      <ul>
        <li>Provide accurate information when using our forms and services.</li>
        <li>Use the platform only for lawful, personal admission-related purposes.</li>
        <li>Verify details such as fees, eligibility and admission processes directly with the institution before applying.</li>
      </ul>

      <h2>Intellectual Property</h2>
      <p>
        The content, branding and materials on this platform are protected and may not be copied or
        reused without permission.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        College Unlock is not liable for decisions made based on the information provided, or for the
        accuracy of third-party data. Use of the platform is at your own discretion.
      </p>

      <h2>Ownership</h2>
      <p data-testid="terms-ownership">
        College Unlock is owned and operated by Spiritual Mantra.
      </p>
    </LegalPageLayout>
  );
}
